import * as Yup from 'yup'
import { Form } from 'formik'
import { useTranslation } from 'react-i18next'
import type { TFunction } from 'i18next'

import { TextFieldInput } from '@dhl/formik'
import { Box, Button, Grid } from '@dhl-ui/components'

export type FormValues = {
  email: string
  firstName: string
  lastName: string
}

export const createValidationSchema = (t: TFunction) =>
  Yup.object({
    email: Yup.string()
      .required(t('admin.adminUsersPage.fieldInputErrorMessage.emailIsRequiredErrorMessage'))
      .email(t('admin.adminUsersPage.fieldInputErrorMessage.emailIsInvalidErrorMessage'))
      .matches(/@dhl.com$/, t('admin.adminUsersPage.fieldInputErrorMessage.emailIsInvalidErrorMessage'))
      .default(''),
    firstName: Yup.string()
      .default('')
      .required(t('admin.adminUsersPage.fieldInputErrorMessage.firstNameIsRequiredErrorMessage')),
    lastName: Yup.string()
      .default('')
      .required(t('admin.adminUsersPage.fieldInputErrorMessage.lastNameIsRequiredErrorMessage')),
  }).defined()

type Props = {
  value?: FormValues
  onCancel: () => void
  isSaving?: boolean
  disabled?: boolean
}

export const AdminUserForm = ({ value, onCancel, isSaving = false, disabled = false }: Props) => {
  const { t } = useTranslation()
  const disableFields = isSaving || disabled

  return (
    <Form data-testid="user-form">
      <Box pt={2} pb={4}>
        <Grid container spacing={2}>
          <Grid>
            <TextFieldInput
              disabled={disableFields}
              fullWidth
              label={t('admin.adminUsersPage.userForm.email')}
              name="email"
              type="text"
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <TextFieldInput
              disabled={disableFields}
              fullWidth
              label={t('admin.adminUsersPage.userForm.firstName')}
              name="firstName"
              type="text"
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <TextFieldInput
              disabled={disableFields}
              fullWidth
              label={t('admin.adminUsersPage.userForm.lastName')}
              name="lastName"
              type="text"
            />
          </Grid>
        </Grid>
      </Box>

      <Box marginTop={2} display="flex" justifyContent="flex-end" gap={1}>
        <Button data-testid="click-cancel" size="medium" color="primary" onClick={onCancel}>
          {t('admin.adminUsersPage.userForm.cancelButtonTitle')}
        </Button>
        <Button size="medium" color="primary" type="submit" variant="contained">
          {value
            ? t('admin.adminUsersPage.userForm.editTitleText')
            : t('admin.adminUsersPage.userForm.saveButtonTitle')}
        </Button>
      </Box>
    </Form>
  )
}
